import type { User } from "@/features/auth/AuthContext";

/**
 * PRR convention: use current authenticated user id as default project id hint.
 * In case backend still uses internal UUID project ids, runtime fallbacks can override it.
 */
export function getPrrProjectId(user: User | null | undefined): string | undefined {
  return user?.id || user?.sub || user?.preferred_username || undefined;
}

